import React from 'react'
import './styles.css'

const Footer = () => {
  return (
    <div className="footer">
      <p>©2020 Andrei Kozel No Rights Reserved</p>
    </div>
  )
}

export default Footer
